var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorporate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.559,
    height: 32.036,
    viewBox: "0 0 37.559 32.036",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_150165",
    "data-name": "Group 150165",
    transform: "translate(0 -37.647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102656",
    "data-name": "Path 102656",
    d: "M18.78,54.217A55.743,55.743,0,0,1,0,51.235V47.589a3.314,3.314,0,0,1,3.314-3.314H9.942v4.419a1.1,1.1,0,1,0,2.209,0V44.275H25.408v4.419a1.1,1.1,0,1,0,2.209,0V44.275h6.628a3.314,3.314,0,0,1,3.314,3.314v3.646a55.743,55.743,0,0,1-18.78,2.982Zm18.78,12.152a3.314,3.314,0,0,1-3.314,3.314H3.314A3.314,3.314,0,0,1,0,66.369v-12.8a58.472,58.472,0,0,0,18.78,2.853,58.47,58.47,0,0,0,18.78-2.853ZM16.018,61.95h5.523a1.1,1.1,0,0,0,0-2.209H16.018a1.1,1.1,0,1,0,0,2.209ZM12.152,44.275H9.942V42.066a4.419,4.419,0,0,1,4.419-4.419H23.2a4.419,4.419,0,0,1,4.419,4.419v2.209H25.408V42.066A2.209,2.209,0,0,0,23.2,39.856H14.361a2.209,2.209,0,0,0-2.209,2.209Z",
    transform: "translate(0 0)",
    fill: "#284261"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporate);
export default __webpack_public_path__ + "static/media/Corporate.62ebd2cc66c102e5a643f8827cb4563d.svg";
export { ForwardRef as ReactComponent };